import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

//CSS
import "../0PageStyles.css";

//Components
import MessageView from "../../Components/Message Components/messageView";

//Functions and hooks

export default function MessagePage() {
  const { t } = useTranslation();

  const tutorialSteps = [
    {
      target: null,
      title: t("Your messages", { ns: "tutorial" }),
      message: t(
        "This is your Messages page - system notifications, employee join requests, and announcements from your company all land here.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".search-bar-container",
      title: t("Search", { ns: "tutorial" }),
      message: t(
        "Search messages by their header, body, or sender.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".sortAndFilterBar",
      title: t("Sort and filter", { ns: "tutorial" }),
      message: t(
        "Sort messages by date, sender, or type, and use Filters to narrow them down.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".selected-options-container",
      title: t("Select and delete", { ns: "tutorial" }),
      message: t(
        "Tick the checkbox to select all messages, refresh the list, or delete the ones you've selected.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".item-card-container .message-card:first-of-type",
      title: t("Message cards", { ns: "tutorial" }),
      message: t(
        "Each card is one message. Click it to read the full message, or accept it directly if it's a join request.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="messages" tutorialSteps={tutorialSteps}>
      <div className="page-content">
        <div className="view-page-container">
          <MessageView />
        </div>
      </div>
    </PageWrapper>
  );
}
